var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16995 0.999634C9.86495 0.999634 11 2.18963 11 3.95963V8.04513C11 9.81013 9.86495 10.9996 8.16995 10.9996H3.83495C2.13995 10.9996 0.99995 9.81013 0.99995 8.04513V3.95963C0.99995 2.18963 2.13995 0.999634 3.83495 0.999634H8.16995ZM5.99495 5.24013C5.75495 5.24013 5.55995 5.43963 5.55995 5.68013V7.89013C5.55995 8.13013 5.75495 8.32513 5.99495 8.32513C6.23995 8.32513 6.43495 8.13013 6.43495 7.89013V5.68013C6.43495 5.43963 6.23995 5.24013 5.99495 5.24013ZM6.00495 3.65513C5.75995 3.65513 5.56495 3.85013 5.56495 4.09513C5.56495 4.33463 5.75995 4.53013 5.99495 4.53013C6.24495 4.53013 6.43995 4.33463 6.43995 4.09513C6.43995 3.85013 6.24495 3.65513 6.00495 3.65513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7779440c6e7edea5a8ca763736820bda.svg";
export { ForwardRef as ReactComponent };